import { getTargetPairsConstants } from '../constants';

const targetPairs = (state, action) => {
    if (state === undefined) {
        return {
            targetPairs: [],
            loading: true,
            error: false,
        };
    }

    switch (action.type) {
        case getTargetPairsConstants.GET_TARGET_PAIRS_REQUEST:
            return {
                targetPairs: [],
                loading: true,
                error: false,
            };

        case getTargetPairsConstants.GET_TARGET_PAIRS_SUCCESS:
            return {
                targetPairs: action.payload,
                loading: false,
                error: false,
            };

        case getTargetPairsConstants.GET_TARGET_PAIRS_FAILURE:
            return {
                targetPairs: [],
                loading: false,
                error: true,
            };

        default:
            return state;
    }
};

export default targetPairs;
